var map = {
	"./calme_shadow.png": "/CRR",
	"./content_shadow.png": "cHXU",
	"./curieux_shadow.png": "RT6L",
	"./fache_shadow.png": "ny0y",
	"./merveilleux_shadow.png": "zyAM",
	"./neutre_shadow.png": "2eDO",
	"./surpris_shadow.png": "398B",
	"./triste_shadow.png": "3PMr"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V355";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions ^\.\/.*_shadow\.png$
// module id = V355
// module chunks = 0